jQuery(document).ready(function ($) {
  let paged = 1;
  var query = window.location.search.substring(1);
  query = query.split("type=")[1];

  const showLoader = () => {
    $(".loader").css("display", "block");
  };

  const hideLoader = () => {
    $(".loader").css("display", "none");
  };

  function loadMoreResults() {
    paged++;
    showLoader();

    $.ajax({
      type: "POST",
      url: sg_loadmore_params.ajaxurl,
      data: {
        action: "load_more_trailers",
        paged: paged,
        type: query,
      },
      success: function (response) {
        if (response.data.html) {
          $(".b-podcasts-wrap.loadmore_results").append(response.data.html);
        } else {
          $(".loadmore_trigger").remove();
          $(".b-podcasts-wrap.loadmore_results").css("padding-bottom", 0);
        }
        if (response.data.post_count < 12) {
          $(".loadmore_trigger").remove();
        }
        hideLoader();
      },
    });
  }

  observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        loadMoreResults();
      }
    });
  });

  const loadMoreTrigger = document.querySelector(".loadmore_trigger");
  if (loadMoreTrigger) {
    observer.observe(loadMoreTrigger);
  }
});
